import type { LucideIcon } from "lucide-react";
import {
  CheckCircle2,
  CircleX,
  ChevronDown,
  ChevronsUp,
  ChevronUp,
  CircleDot,
  Clock,
  Equal,
  PauseCircle,
} from "lucide-react";

import type { TaskPriority, TaskStatus } from "@recobra/schemas/task";

export const TASK_STATUS_CONFIG: Record<TaskStatus, { textClassName: string; icon: LucideIcon }> = {
  canceled: { textClassName: "text-muted-foreground", icon: CircleX },
  todo: {
    textClassName: "text-foreground",
    icon: Clock,
  },
  in_progress: {
    textClassName: "text-info",
    icon: CircleDot,
  },
  waiting: {
    textClassName: "text-warning",
    icon: PauseCircle,
  },
  done: {
    textClassName: "text-success",
    icon: CheckCircle2,
  },
};

export const TASK_PRIORITY_CONFIG: Record<
  TaskPriority,
  {
    icon: LucideIcon;
    iconClassName: string;
  }
> = {
  low: {
    icon: ChevronDown,
    iconClassName: "text-green-600",
  },
  medium: {
    icon: Equal,
    iconClassName: "text-yellow-600",
  },
  high: {
    icon: ChevronUp,
    iconClassName: "text-orange-600",
  },
  critical: {
    icon: ChevronsUp,
    iconClassName: "text-red-600",
  },
};

/** Highest priority first, matching Jira-style priority pickers. */
export const TASK_PRIORITY_ORDER: readonly TaskPriority[] = ["critical", "high", "medium", "low"];
